import React from 'react';
import { useTranslation } from 'react-i18next';
import { OrderingSelectors } from 'polygon-ordering';
import getThemeLookup from '../selectors/getThemeLookup';
import { useAppSelector } from '../app/hooks';

import Text from './Text';
import { SALE_TYPE } from '../libs/polygon-ordering/src/constants/saleType';
import combineStyles from '../utils/combineStyles';
import { TEXT_PROPERTIES } from '../utils/theme';

const { getSaleType, getLocation, getTable } = OrderingSelectors;

const OrderPropertySaleType = () => {
  const { t } = useTranslation();
  const p = useAppSelector(getThemeLookup);

  const saleType = useAppSelector(getSaleType);
  const location = useAppSelector(getLocation);
  const tableNumber = useAppSelector(getTable);

  if (saleType == null) {
    return null;
  }

  const textStyle = combineStyles([
    { textAlign: 'center' },
    p('locationNameCartModal', TEXT_PROPERTIES),
  ]);

  switch (saleType) {
    case SALE_TYPE.DINE_IN || saleType === SALE_TYPE.TABLE_ORDER:
      return (
        <Text variant="h3" style={textStyle}>
          {tableNumber ? t('table') + ` ${tableNumber}` : t('tableOrder.pleaseSelectATable')}
        </Text>
      );
    case SALE_TYPE.DELIVERY:
      return (
        <Text style={textStyle} themeKey="orderPropertyButton" variant="h3">
          {t(`saleType.${saleType}.name`)}
        </Text>
      );
    default:
      return (
        <Text style={textStyle} themeKey="orderPropertyButton" variant="h3">
          {t(`saleType.${saleType}.name`) + ` - ${location?.name}`}
        </Text>
      );
  }
};

export default OrderPropertySaleType;
